import React, { Suspense } from "react"
import BackToTop from "./backToTop"
import withRouter from "../../common/data/withRouter"

// Layout Components
const NettaNavbar = React.lazy(() => import("./NettaNavbar"))
const Footer = React.lazy(() => import("./Footer"))

const Loader = () => {
  return (
    <div id="preloader">
      <div id="status">
        <div className="spinner">
          <div className="double-bounce1"></div>
          <div className="double-bounce2"></div>
        </div>
      </div>
    </div>
  )
}

const Layout = ({ children, router }) => {
  return (
    <React.Fragment>
      <Suspense fallback={<Loader />}>
        <NettaNavbar />
        {children}
        <Footer />
        <BackToTop />
      </Suspense>
    </React.Fragment>
  )
}

export default withRouter(Layout)
